import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import fetch function */
import { SettingMaxGroupNum } from "../../../services/events";

const CreateDevice = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        delete error[name];

        _source[name] = value;
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {     
            SettingMaxGroupNum(source).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['maxTeamSize'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Setting</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label lg-label'>Max People in a Group</div>
                        <span className='semicolon'>：</span>
                        <Form.Control type='number' name='maxTeamSize' placeholder='Please enter the count of a group.' is-required={`${error.maxTeamSize}`} onChange={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateDevice;